<template>
	<div class="wrapper">
		<div v-if="loading" class="text-center">
			<b-spinner label="Loading..." style="width: 3rem; height: 3rem;" variant="info"></b-spinner>
		</div>
		<div v-else class="animated fadeIn">
			<b-row>
				<b-col cols="12">
					<b-card header-tag="header">
						<genericTable
							:table-data="expiredSubscribersTableData"
							:fields="expiredSubscriberListFields"
							:per-page=50
							hover striped bordered small
							caption="<i class='icon-list'></i> List of Expired Subscribers"
							:filter="true">
						</genericTable>
					</b-card>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import genericTable from '@/components/GenericTable';
import subscriptionService from "@/services/subscriptionService";
import toastService from "@/services/toastService";
import moment from 'moment';

export default {
	name : "DueStatus",
	components : {
		"genericTable": genericTable
	},
	data : function () {
		return {
			loading : false,
			expiredSubscriberList : [],
			expiredSubscriberListFields : [
				{key: 'id', label: 'ID', sortable: true, class: 'text-center', thStyle: "width: 5%"},
				{key: 'invoice_id', label: 'Invoice ID', sortable: true, class: 'text-center', thStyle: "width: 10%"},
				{key: 'project_id', label: 'Project ID', sortable: true, class: 'text-center', thStyle: "width: 10%"},
				{key: 'project_name', label: 'Project Name', sortable: true, searchable: true, class: 'text-center',},
				{key: 'subscription_amount', label: 'Amount', sortable: true, class: 'text-center', thStyle: "width: 6%"},
				{key: 'expiry_date', label: 'Expiry Date', sortable: true, class: 'text-center', thStyle: "width: 20%"},
				{key: 'status', label: 'Status', sortable: true, class: 'text-center', thStyle: "width: 5%"}
			]
		}
	},
	methods : {
		getAllExpiredSubscriptions : function () {
			subscriptionService.getAllExpiredSubscriptions((data) => {
				this.createExpiredSubscriptionListTable(data);
				this.loading = false;
			}, (error) => {
				toastService.showErrorToast("Could not fetch expired subscriptoin list " + error);
			});
		},
		createExpiredSubscriptionListTable : function (data) {
			data.forEach((value, index) => {
			let row = new Object();
				row.id = value.id;
				row.invoice_id = value.invoiceId;
				row.project_id = value.subscriberProjectId;
				row.project_name = value.subscriberProjectName;
				row.subscription_amount = value.amount.toFixed(2);
				row.expiry_date = (value.expiryDate != null) ? moment(value.expiryDate).format('DD-MM-YYYY') : "N/A";
				row.status = value.status;
				this.expiredSubscriberList.push(row);
			});
		}
	},
	created() {
		this.loading = true;
		this.getAllExpiredSubscriptions();
	},
	computed : {
		expiredSubscribersTableData : function () {
			return this.expiredSubscriberList;
		}
	}
}
</script>

<style scoped>

</style>
